import { ContactUsForm } from 'components/commercetools-ui/static-page-forms/contact-form';

export const CorporateFormTastic = (props) => {
  const { data } = props;
  return <ContactUsForm data={data} isCorporateForm={true} />;
};
